angular.module("ainapp")
    .controller("productListController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Product List";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {
                $scope.filter = {
                    Keyword: "",
                    AccountKeyword:""
                }
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.ProductType = "Product";
                        
                        o.data.Keyword = $scope.filter.Keyword;
                        o.data.AccountKeyword = $scope.filter.AccountKeyword;
                        MainService.ProductList(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            "Unit.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Brand.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Country.Name": {
                                type: "string",
                                editable: false,
                            },
                            BarCode: {
                                type: "string",
                                editable: false,
                            },
                            GroupName: {
                                type: "string",
                                editable: false,
                            },
                            ParentGroupName: {
                                type: "string",
                                editable: false,
                            },
                            Image: {
                                type: "string",
                                editable: false,
                            },
                            SellPrice: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice: {
                                type: "number",
                                editable: false,
                            },
                            Description: {
                                type: "string",
                                editable: false,
                            },
                            Field9: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [{
                    field: "BalanceValue",
                    aggregate: "sum"
                    }, {
                    field: "Balance",
                    aggregate: "sum"
                    }, ],
            });

            $scope.KendoGridOptions = {



                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "Image",
                        title: "Photo",
                        template: '<img  src="{{basePath}}{{dataItem.Image}}" style="width:30px;height:30px;" />',
                        headerTemplate: "{{LanguageData.Photo}}",
                        width: "80px"
                                    },
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                        },
                    {
                        field: "Brand.Name",
                        title: "Brand",
                        },
                    {
                        field: "Country.Name",
                        title: "Country",
                        },
                    {
                        field: "ProductCode",
                        title: "Product Code",
                        },
                    {
                        field: "ParentGroupName",
                        title: "Parent Group",
                        width: '200px'
                        },
                    {
                        field: "GroupName",
                        title: " Group",
                        width: '200px'
                        },
//                    {
//                        field: "BarCode",
//                        title: "Bar Code",
//                        },
                    {
                        field: "Unit.Name",
                        title: "Unit",
                        },
//                    {
//                        field: "SellPrice",
//                        title: "Sell Price",
//                        template: "<div style='text-align: right'>#=kendo.toString(SellPrice, 'n')#</div>",
//
//                        },
//                    {
//                        field: "PurchasePrice",
//                        title: "Purchase Price",
//                        template: "<div style='text-align: right'>#=kendo.toString(PurchasePrice, 'n')#</div>",
//
//                        },
                    {
                        field: "Description",
                        title: "Remarks",
                        },
                    {
                        field: "Field9",
                        title: "Manuf.",
                        },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='deleteProduct(dataItem)'></button> </button> <button class=' btn-default btn-sm fa fa-print'  ng-click='printPdf(dataItem)'></button>  </button> <button class=' btn-default btn-sm fa fa-id-card'  ng-click='printLabel(dataItem)'></button></button> <button class=' btn-default btn-sm fa fa-balance-scale'  ng-click='goConversion(dataItem)'></button> <button ng-if='CompanyProfile.IsRecipe' class=' btn-default btn-sm fa fa-bars'  ng-click='goRecipe(dataItem)'></button> <button  class=' btn-default btn-sm fa fa-adjust'  ng-click='openAdjModal(dataItem)'></button>",
                        width: '200px'
                        },
                    ],
            };

            $scope.search = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Edit = function (data) {
                $state.go("editProduct", {
                    ItemId: data.Id
                })
            }

            $scope.SelectedDataForDelete = {};
            $scope.deleteProduct = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#deletemodal").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteProduct($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == 1) {
                        $('#deletemodal').modal('hide');
                        toastr.success("Deleted");
                        $scope.SelectedDataForDelete = {};
                        $scope.Init();
                    } else if (response.data == 2) {
                        $('#deletemodal').modal('hide');
                        toastr.warning("Product In Use");
                    } else if (response.data == 3) {
                        $('#deletemodal').modal('hide');
                        toastr.warning("Delete Sub Products First");
                    } else {
                        toastr.warning("Failed");
                    }
                    $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }



            $scope.goConversion = function (data) {
                $state.go("UnitConvertionProduct", {
                    ProductId: data.Id
                })
            }


            $scope.goRecipe = function (data) {
                $state.go("recipe", {
                    productId: data.Id
                })
            }


            $scope.printPdf = function (data) {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });


                MainService.PrintProductLabel(data.Id).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }


            //////////////////// Adjustments /////////////////////////////////

            $scope.AdjustmentItem = {};
            $scope.openAdjModal = function (data) {
                $scope.AdjustmentItem = data;
                $('#adjustmentModal').modal('show');
            }

            $scope.ResaveSalesInvoiceGL = function () {

                var temp = {
                    ProductIds: []
                }

                temp.ProductIds.push($scope.AdjustmentItem.Id);

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ResaveAllProductSalesInvoiceGLFIFO(temp).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $('#adjustmentModal').modal('hide');
                        $scope.init();
                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });

            }


        }])
